import React, { useEffect, useState, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import Form from 'react-bootstrap/Form';
import { useDropzone } from 'react-dropzone';
import { RadioButton } from "primereact/radiobutton";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputSwitch } from 'primereact/inputswitch'; // Import InputSwitch component
import { Button } from 'primereact/button'; // Import Button for icons
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import Loader from '../loader/loader'
import useToastNotification from '../../hooks/useToastNotification';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Skeleton } from 'primereact/skeleton';

import { CreatePopup, SearchPopup, GetPopup, UpdatePopup, DeletePopup } from '../../utils/api'
//icons

import Upload from '../../assets/icons/upload.svg'
import Edit from '../../assets/icons/edit.svg'
import Trash from '../../assets/icons/trash.svg'
import Icx from '../../assets/icons/icx.svg'


function Banner() {
    const [addFormValidated, setAddFormValidated] = useState(false);
    const [editFormValidated, setEditFormValidated] = useState(false);
    const [visible, setVisible] = useState(false)
    const [editvisible, setEditVisible] = useState(false)
    const [checkedbtn, setCheckedbtn] = useState(false)
    const [text, setText] = useState('')
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(false);
    const { showError, showSuccess } = useToastNotification();

    const [textBtn, setTextBtn] = useState('')
    const [linkBtn, setLinkBtn] = useState('')
    const datePickerRef = useRef(null);
    const datePickerRef1 = useRef(null);
    const [date, setDates] = useState();
    const [items, setItems] = useState([]);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    // isSettingTo uses only when the 'to date' datepicker opens to detect user's setting the 'to date' and prevent setting the 'from date' again.
    const [isSettingTo, setIsSettingTo] = useState(false);
    const [isSettingfrom, setIsSettingfrom] = useState(false);
    const initialSelectedItemProperties = {
        "text": "",
        "buttonText": "",
        "isActive": true,
        "link": "",
    };
    const [selectedItem, setSelectedItem] = useState({ ...initialSelectedItemProperties });

    const loadPopup = async (page = pageIndex, size = pageSize) => {
        setLoading(true)
        try {
            let response = await SearchPopup({
                pageIndex: page,
                pageSize: size,
            });
            setItems(response.data.data.items);
            setTotalRecords(response.data.data.total);
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    };

    const loadPage = async () => {
        loadPopup();
    };
    useEffect(() => {
        let data = [];
        setItems(data);
        loadPage();

    }, [pageIndex, pageSize]);
    const onDateRangeChanged = (location, e) => {
        if (isSettingfrom) {
            handleFocus1()
            closefromCalendar()
        } else if (!isSettingfrom && !isSettingTo) {
            handleFocus()
            closeToCalendar()
        }
        if (isSettingTo) {
            if (e[0].format().toString() == date[0].format().toString()) {
                setDates(e);
            } else {
                setDates((old) => {
                    old[1] = e[0];
                    return old;
                });
                setIsSettingTo(false);
            }


        }
        else {
            setDates(e);
        }
    };
    const onCalenderOpened = (e) => {

        if (e === 'to') {
            setIsSettingTo(true);
            setIsSettingfrom(false)
        }
        if (e === 'from') {
            setIsSettingfrom(true)
            setIsSettingTo(false);

        }

    };
    const handleFocus1 = () => {
        if (datePickerRef1.current) {
            datePickerRef1.current.openCalendar();
        }
    };
    const formatDateObject = (dateObject) => {
        if (!dateObject) return "";
        const startDate = dateObject.split(' ~ ')[0];
        return startDate;
    };
    const formatDateObjectTo = (dateObject) => {
        if (!dateObject) return "";
        const endDate = dateObject.split(' ~ ')[1];
        return endDate;
    };
    const handleFocus = () => {
        if (datePickerRef.current) {
            datePickerRef.current.openCalendar();
        }
    };
    const closefromCalendar = () => {
        if (datePickerRef.current) {
            datePickerRef.current.closeCalendar();
        }
    };
    const closeToCalendar = () => {
        if (datePickerRef1.current) {
            datePickerRef1.current.closeCalendar();
        }
    };
    const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"]

    // When the date range changes, update fromDate and toDate



    // Handle the toggle of the InputSwitch
    const onStatusChange = async (rowData, value) => {



        const updatedItem = {
            ...rowData,
            isActive: value
        };
        await UpdatePopup(updatedItem).then(() => {
            const updatedItems = items.map(item =>
                item.id === rowData.id ? { ...item, isActive: value } : item
            );
            setItems(updatedItems);
            showSuccess("عملیات با موفقیت انجام شد");
        }).catch(error => showError(error));
    };


    // Status switch template for the "وضعیت" column
    const statusSwitchTemplate = (rowData) => {
        return (
            <InputSwitch
                checked={rowData.isActive}
                onChange={(e) => onStatusChange(rowData, e.value)}
            />
        );
    };
    const openEditDialog = (rowData) => {
        if (rowData.buttonText) {
            setCheckedbtn(true)
        }
        setDates([
            rowData.fromDate,
            rowData.toDate,
        ])
        setSelectedItem(rowData);
        setEditVisible(true);
        document.body.style.overflow = 'hidden'; // غیرفعال کردن اسکرول

    };
    const updateSelectedItem = (key, value) => {
        setSelectedItem(old => {
            let clone = { ...old };
            clone[key] = value;
            return clone;
        })
    };

    const submitEdit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === true) {
            setLoading(true);




            // Create the updated item to send to the server
            const updatedItem = {
                ...selectedItem,
            };

            try {
                console.log(updatedItem);
                let response = await UpdatePopup(updatedItem); // Send updated item to server
                if (response.status === 200) {
                    setItems(old => {
                        let clone = [...old];
                        clone = clone.map(item => {
                            if (item.id === updatedItem.id) {
                                return updatedItem; // Update the item with the new data
                            }
                            return item;
                        });
                        return clone;
                    });
                    showSuccess("عملیات با موفقیت انجام شد");
                    closeEditDialog();
                }
            } catch (error) {
                showError(error.response.data.message);
            } finally {
                setLoading(false);
            }
        } else {
            setEditFormValidated(true);
        }
    };

    const closeEditDialog = (forceClose = false) => {
        if (loading === true && forceClose !== true) return;
        // setUploadStatus("");
        loadPage()
        setEditVisible(false);
        document.body.style.overflow = 'auto'; // فعال کردن مجدد اسکرول

    };
    const deleteItem = async (item) => {
        await DeletePopup({ id: item.id }).then(() => {
            showSuccess("عملیات با موفقیت انجام شد");
            setItems(old => old.filter(filter => item.id !== filter.id));
        }).catch(error => {
            showError(error.response.data.message);
        });
    };
    const openDeleteDialog = async (rowData) => {
        document.body.style.overflow = 'hidden'; // غیرفعال کردن اسکرول

        confirmDialog({
            message: 'آیا از حذف آیتم اطمینان دارید؟',
            header: 'حذف آیتم',
            defaultFocus: 'reject',
            maskClassName: 'flex',
            headerClassName: '!pr-1 !pl-1',
            acceptClassName: 'btn btn-danger mx-1',
            rejectClassName: 'btn btn-secondary mx-1',
            acceptLabel: 'حذف',
            rejectLabel: 'انصراف',
            resizable: false,
            accept: () => {
                deleteItem(rowData)
                document.body.style.overflow = 'auto';
            },
            reject: () => {
                document.body.style.overflow = 'auto'; // فعال کردن مجدد اسکرول
            },
        });
    };


    // Icon template for "عملیات" column
    const actionTemplate = (rowData) => {
        return (
            <div className='d-flex justify-content-center gap-2' style={{ borderRight: '0.5px solid #D2D2D2' }}>
                <img
                    src={Edit}
                    alt="edit"
                    className="cursor-pointer mx-1"
                    onClick={() => openEditDialog(rowData)}
                    style={{ width: '24px', height: '24px' }}
                />
                <img
                    src={Trash}
                    alt="delete"
                    className="cursor-pointer mx-1"
                    onClick={() => openDeleteDialog(rowData)}
                    style={{ width: '24px', height: '24px' }}
                />
            </div>
        );
    };


    function convertPersianDigitsToEnglish(text) {
        // Define a mapping of Persian digits to English digits
        const persianToEnglishDigits = {
            '۰': '0',
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9'
        };

        // Use a regular expression to find Persian digits and replace them
        return text.replace(/[۰-۹]/g, function (match) {
            return persianToEnglishDigits[match];
        });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === true) {
            try {
                setLoading(true);

                let payload = {
                    buttonText: textBtn,
                    link: linkBtn,
                    text: text,
                    isActive: status,
                    fromDate: convertPersianDigitsToEnglish(date[0].format()),
                    toDate: convertPersianDigitsToEnglish(date[1].format()),
                };

                let res = await CreatePopup(payload)
                if (res.data.isSuccess) {
                    const id = res.data.data; //created item id
                    setLoading(false);
                    closeAddDialog();
                    loadPage()
                    showSuccess("عملیات با موفقیت انجام شد");
                }


            } catch (error) {
                setLoading(false);
                showError(error.response?.data?.message);
            }
        } else {
            setAddFormValidated(true);
        }

    };

    const closeAddDialog = (forceClose = false) => {
        if (loading === true && forceClose !== true) return;
        setCheckedbtn("");
        setAddFormValidated(true);
        setVisible(false);
        document.body.style.overflow = 'auto'; // فعال کردن مجدد اسکرول

        // reset properties to default
        setDates([]);
        setLinkBtn([]);
        setText("");
        setTextBtn("");
    };
    // قالب اسکلتون
    const skeletonBodyTemplate = () => {
        return <Skeleton width="100%" height="1.5rem" />;
    };
    const handlePagination = (event) => {
        // Update the pageIndex and pageSize based on the event
        setPageIndex(event.page + 1);
        setPageSize(event.rows);

        loadPopup(event.page, event.rows);
    };
    return (
        <>

            <div className='w-100 d-flex justify-content-between bg-white p-2 align-items-center border-solid border'>
                <h6 className='font-bold text-sm mb-0'>پاپ آپ‌ها</h6>
                <button className='btn btn-primary' onClick={() => {
                    setVisible(true)
                    document.body.style.overflow = 'hidden'; // غیرفعال کردن اسکرول

                }}>افزودن پاپ آپ</button>

            </div>
            <div className=''>
                <DataTable value={items}
                    size="small"
                    paginator
                    rows={pageSize}
                    totalRecords={totalRecords}
                    lazy
                    onPage={handlePagination}
                    first={(pageIndex - 1) * pageSize} // Current first record index
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                    tableStyle={{ minWidth: '50rem' }}
                >
                    <Column field="id" header="ردیف" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column field="text" header="متن" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column field="fromDate" header="از تاریخ" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column field="toDate" header="تا تاریخ" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column field="buttonText" header="متن دکمه" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column header="وضعیت" body={statusSwitchTemplate}></Column>
                    <Column header="عملیات" body={actionTemplate} ></Column>
                </DataTable>
            </div>





            {/* add popup  */}
            <Dialog header="افزودن پاپ آپ" visible={visible} maximizable style={{ width: '40vw' }} onHide={() => {
                if (!visible) return; {
                    setVisible(false);
                    document.body.style.overflow = 'auto'; // فعال کردن مجدد اسکرول

                }
            }}>
                <div className='dialog-body mx-4'>
                    <Form noValidate validated={addFormValidated} className='mt-3' action='#' onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>متن پاپ آپ</Form.Label>
                            <Form.Control type="text" required value={text} onChange={(e) => setText(e.target.value)} />
                            <Form.Control.Feedback type="invalid">
                                متن پاپ آپ را وارد کنید
                            </Form.Control.Feedback>
                        </Form.Group>
                        <div className='row'>
                            <Form.Group className=" col-6">
                                <Form.Label>از تاریخ</Form.Label>
                                <DatePicker
                                    range
                                    numberOfMonths={2}
                                    showOtherDays
                                    value={date}
                                    onChange={(e) => onDateRangeChanged('from', e)}
                                    onOpen={() => onCalenderOpened('from')}
                                    calendar={persian}
                                    weekDays={weekDays}
                                    locale={persian_fa}
                                    required
                                    render={(value) => {
                                        const fromDateFormatted = formatDateObject(value);
                                        return <input className='form-control f-1m' readOnly onFocus={handleFocus} value={fromDateFormatted} />;
                                    }}
                                    ref={datePickerRef}
                                    onClose={() => console.log()}
                                />
                                <Form.Control.Feedback type="invalid">
                                    تاریخ را وارد کنید
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className=" col-6">
                                <Form.Label>تا تاریخ</Form.Label>
                                <DatePicker
                                    range
                                    numberOfMonths={2}
                                    showOtherDays
                                    value={date}
                                    onChange={(e) => onDateRangeChanged('to', e)}
                                    onOpen={() => onCalenderOpened('to')}
                                    calendar={persian}
                                    weekDays={weekDays}
                                    locale={persian_fa}
                                    render={(value) => {
                                        const fromDateFormatted = formatDateObjectTo(value);
                                        return <input className='form-control f-1m' readOnly onFocus={handleFocus1} value={fromDateFormatted} />;
                                    }}
                                    required
                                    ref={datePickerRef1}
                                    onClose={() => console.log()}
                                />
                                <Form.Control.Feedback type="invalid">
                                    تاریخ را وارد کنید
                                </Form.Control.Feedback>
                                {/* <DatePicker
                                    // readOnly
                                    value={toDate}
                                    // onChange={setDates}
                                    calendar={persian}
                                    locale={persian_fa}
                                /> */}
                            </Form.Group>
                        </div>
                        <div className='d-flex align-items-center justify-content-between'>
                            <Form.Group className="mb-3 mt-3 d-flex align-items-center justify-content-start gap-3" controlId="exampleForm.ControlInput1">
                                <InputSwitch checked={status} onChange={(e) => setStatus(e.value)} />
                                <Form.Label className='font-bold mb-0' style={{ width: 'fit-content', fontWeight: '700 !important' }}>وضعیت</Form.Label>
                            </Form.Group>
                            <Form.Group className="mb-3 mt-3 d-flex align-items-center justify-content-start gap-3" controlId="exampleForm.ControlInput1">
                                <InputSwitch checked={checkedbtn} onChange={(e) => setCheckedbtn(e.value)} />
                                <Form.Label className='font-bold mb-0' style={{ width: 'fit-content', fontWeight: '700 !important' }}>تعریف دکمه</Form.Label>
                            </Form.Group>
                        </div>
                        {checkedbtn ?
                            <div>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>متن دکمه</Form.Label>

                                    <Form.Control type="text" required value={textBtn} onChange={(e) => setTextBtn(e.target.value)} />
                                    <Form.Control.Feedback type="invalid">
                                        متن دکمه را وارد کنید
                                    </Form.Control.Feedback>

                                </Form.Group>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>لینک دکمه</Form.Label>
                                    <Form.Control type="text" required value={linkBtn} onChange={(e) => setLinkBtn(e.target.value)} />
                                    <Form.Control.Feedback type="invalid">
                                        لینک دکمه را وارد کنید
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div> : <div></div>
                        }
                        {/* <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <Form.Label>شماره تصویر</Form.Label>
                            <Form.Control type="number" placeholder="123456" value={imageNum} onChange={(e) => setImageNum(e.target.value)} />
                        </Form.Group> */}
                        <button type="submit" disabled={loading} className="btn btn-primary w-100 mt-4">تایید و ثبت {loading && <Loader />}</button>
                    </Form>


                </div>
            </Dialog>


            {/* Edit popup  */}
            <Dialog header="ویرایش پاپ آپ" visible={editvisible} maximizable style={{ width: '40vw' }} onHide={() => {
                if (!editvisible) return; {
                    setEditVisible(false);
                    document.body.style.overflow = 'auto'; // فعال کردن مجدد اسکرول

                }
            }}>
                <div className='dialog-body mx-4'>
                    <Form noValidate validated={editFormValidated} className='mt-3' onSubmit={submitEdit} onKeyUp={(e) => (e.key === "Enter") && e.preventDefault()}>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>متن پاپ آپ</Form.Label>
                            <Form.Control type="text" required value={selectedItem.text} onChange={(e) => updateSelectedItem('text', e.target.value)} />
                            <Form.Control.Feedback type="invalid">
                                متن پاپ آپ را وارد کنید
                            </Form.Control.Feedback>
                        </Form.Group>
                        <div className='row'>
                            <Form.Group className=" col-6">
                                <Form.Label>از تاریخ</Form.Label>
                                <DatePicker
                                    range
                                    numberOfMonths={2}
                                    showOtherDays
                                    value={date}
                                    onChange={(e) => onDateRangeChanged('from', e)}
                                    onOpen={() => onCalenderOpened('from')}
                                    calendar={persian}
                                    weekDays={weekDays}
                                    locale={persian_fa}
                                    required
                                    render={(value) => {
                                        const fromDateFormatted = formatDateObject(value);
                                        return <input className='form-control f-1m' readOnly onFocus={handleFocus} value={fromDateFormatted} />;
                                    }}
                                    ref={datePickerRef}
                                    onClose={() => console.log()}
                                />
                                <Form.Control.Feedback type="invalid">
                                    تاریخ را وارد کنید
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className=" col-6">
                                <Form.Label>تا تاریخ</Form.Label>
                                <DatePicker
                                    range
                                    numberOfMonths={2}
                                    showOtherDays
                                    value={date}
                                    onChange={(e) => onDateRangeChanged('to', e)}
                                    onOpen={() => onCalenderOpened('to')}
                                    calendar={persian}
                                    weekDays={weekDays}
                                    locale={persian_fa}
                                    required
                                    render={(value) => {
                                        const fromDateFormatted = formatDateObjectTo(value);
                                        return <input className='form-control f-1m' readOnly onFocus={handleFocus1} value={fromDateFormatted} />;
                                    }}
                                    ref={datePickerRef1}
                                    onClose={() => console.log()}
                                />
                                <Form.Control.Feedback type="invalid">
                                    تاریخ را وارد کنید
                                </Form.Control.Feedback>
                                {/* <DatePicker
                                    // readOnly
                                    value={toDate}
                                    // onChange={setDates}
                                    calendar={persian}
                                    locale={persian_fa}
                                /> */}
                            </Form.Group>
                        </div>
                        <div className='d-flex align-items-center justify-content-between'>
                            <Form.Group className="mb-3 mt-3 d-flex align-items-center justify-content-start gap-3" controlId="exampleForm.ControlInput1">
                                <InputSwitch checked={selectedItem.isActive} onChange={(e) => updateSelectedItem('isActive', !selectedItem.isActive)} />
                                <Form.Label className='font-bold mb-0' style={{ width: 'fit-content', fontWeight: '700 !important' }}>وضعیت</Form.Label>
                            </Form.Group>
                            <Form.Group className="mb-3 mt-3 d-flex align-items-center justify-content-start gap-3" controlId="exampleForm.ControlInput1">
                                <InputSwitch checked={checkedbtn} onChange={(e) => setCheckedbtn(e.value)} />
                                <Form.Label className='font-bold mb-0' style={{ width: 'fit-content', fontWeight: '700 !important' }}>تعریف دکمه</Form.Label>
                            </Form.Group>
                        </div>

                        {checkedbtn ?
                            <div>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>متن دکمه</Form.Label>

                                    <Form.Control type="text" required value={selectedItem.buttonText} onChange={(e) => updateSelectedItem('buttonText', e.target.value)} />

                                    <Form.Control.Feedback type="invalid">
                                        متن دکمه را وارد کنید
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>لینک دکمه</Form.Label>
                                    <Form.Control type="text" required value={selectedItem.link} onChange={(e) => updateSelectedItem('link', e.target.value)} />
                                    <Form.Control.Feedback type="invalid">
                                        لینک دکمه را وارد کنید
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div> : <div></div>
                        }
                        {/* <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <Form.Label>شماره تصویر</Form.Label>
                            <Form.Control type="number" placeholder="123456" value={imageNum} onChange={(e) => setImageNum(e.target.value)} />
                        </Form.Group> */}
                        <div className='d-flex align-items-center gap-2'>
                            <button type="submit" disabled={loading} className="btn btn-primary flex-1">  تایید و ثبت{loading === true && <Loader />}</button>
                            <button type="button" className="btn btn-outline-primary flex-1" onClick={() => {
                                setEditVisible(false);
                                document.body.style.overflow = 'auto';
                            }}>انصراف</button>

                        </div>
                    </Form>

                </div>
            </Dialog>
        </>
    )
}
export default Banner;
